
export default function NoAssignee() {
  return (
    <div className="flex flex-col items-center">
      <div className="text-gray-600">-</div>
    </div>
  );
}
